import _ from 'lodash';

import * as ActionTypes from '../actions/actionTypes';

const initialState = {
    clients:        [],
    selectedClient: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_CLIENTS:
            return {
                ...state,
                clients: [...action.payload]
            };
        case ActionTypes.SET_CLIENT: {
            const selectedClient = _.isEmpty(action.payload) ? null : {...action.payload};

            return {
                ...state,
                selectedClient
            };
        }
        default:
            return state;
    }
};
